import React from "react";

function ProcessDescription({ processData, dataFormato }) {
  return (
    <div className="tab-pane fade show active" id="primeira-aba" role="tabpanel">
      <div className="card-body table-responsive p-0">
        <table className="table table-striped table-bordered mt-10">
          <tbody>
            <tr>
              <td>
                <b>Número do Processo:</b> {processData.processo}
              </td>
              <td>
                <b>Fórum:</b> {processData.forum}
              </td>
            </tr>
            <tr>
              <td width="50%">
                <b>Data do Cadastro:</b> {dataFormato(processData.data_cadastro)}
              </td>
              <td width="50%">
                <b>Pasta:</b> {processData.pasta}
              </td>
            </tr>
            <tr>
              <td>
                <b>Valor da Causa:</b> {processData.valor_causa}
              </td>
              <td>
                <b>Status:</b> {processData.status}
              </td>
            </tr>
            <tr>
              <td>
                <b>Período Inicial:</b> {dataFormato(processData.data_inicio)}
              </td>
              {/* <td>
                <b>Período Final:</b> {dataFormato(processData.data_estimada)}
              </td> */}
            </tr>
            <tr>
              <td>
                <b>Observação:</b> {processData.observacao}
              </td>
              <td>
                <b>Valor Total dos Pagamentos:</b> {processData.valor_total}
              </td>
            </tr>
            <tr>
              <td>
                <b>Advogado(a) do Réu:</b> {processData.advogado}
              </td>
              <td>
                <b>Réu:</b> {processData.reu}
              </td>
            </tr>
            <tr>
              <td>
                <b>Advogado(a) do Autor:</b> {processData.advAutor}
              </td>
              <td>
                <b>Autor:</b> {processData.autor}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <form action={`/api/observation/${processData.id}`} method="post">
        <div className="col-md-12">
          <div className="form-group" style={{ marginTop: 13 }}>
            <i className="fa fa-comment"></i>
            <label>Comentários</label>
            <textarea
              id="comentarios"
              className="form-control"
              name="observation"
              rows="6"
              placeholder="Deixe aqui seu comentário..."
              required
            ></textarea>
          </div>
          <div className="col-xs-12 text-center">
            <button className="btn btn-info" id="comentar" type="submit">
              <i className="fa fa-comment"></i> Comentar
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}

export default ProcessDescription;
